export interface ZipCodeResult {
    id: number
    prefecture_id: number
    prefecture_name: string
    city_id: number
    city_name: string
    postal_code: string
    name: string
}

export interface ZipCodeResponse {
    status: string
    total?: number
    message?: string
    data?: ZipCodeResult[]
}

export type ApiResponseError =
    | {
          status: number
          message: string
      }
    | Error

export const zipCodeError = (message): ApiResponseError => ({
    status: 400,
    message: message,
})
